module.exports = __webpack_public_path__ + "static/media/logo.ee63e33a.png";